
// @module ProductDetails
define('Code25.Product', [

    'Code25.ProductOptions.View',"Tools","Utils","ProductList.Model"
], function (

    ProductOptionsView,Tools,Utils,ProductListModel
) {
    'use strict';

    return {
			mount: function (container) {

                var FacetsBrowseView=require("Facets.Browse.View");

                 if (FacetsBrowseView) {
                    FacetsBrowseView.prototype.getCanonical=function() {
        var canonical_url = this.getPath();
        
        if(canonical_url&&canonical_url.indexOf("/segments/")>-1){
Backbone.history.navigate("/", { trigger: true, replace: true });
        }
        const current_page = this.translator.getOptionValue('page');

        if (current_page > 1) {
            canonical_url += `?page=${current_page}`;
        }

        return canonical_url;
    }
                 }

    var ProductDetailsFullView = require('ProductDetails.Full.View');
          if (ProductDetailsFullView) {

            ProductDetailsFullView.prototype.childViews.ProductOptions = function () {
              return new ProductOptionsView({
                model: this.model
                , application: this.application
                , show_pusher: this.showOptionsPusher()
                , show_required_label: this.model.get('item').get('itemtype') === 'GiftCert'
              });
            };

            _.extend(ProductDetailsFullView.prototype, {

              getContext: _.wrap(ProductDetailsFullView.prototype.getContext, function (getContext) {

                var res = getContext.apply(this, _.rest(arguments));

                var item = this.model.get("item");

                var item_matrix_children = item.get('_matrixChilds') || [];
                res.isMatrix = item_matrix_children.length > 0

                return res;
              })
            });
            
        }

        var ProductListControlView = require('ProductList.Control.View');
          if (ProductListControlView) {
            if (ProductListControlView.ProductListControlView) {
              ProductListControlView = ProductListControlView.ProductListControlView;
            }
              ProductListControlView.prototype.showFlyout = function (e) {

                var matrixquantities = this.product.get("matrixquantities") || {};

                e.stopPropagation();
                e.preventDefault();
                var valid = false;
                for (var q in matrixquantities) {

                  if (matrixquantities[q] > 0) {
                    valid = true; //there must be a valid item.
                  }
                }
                

                //Here no extra validation is specified as those are not required to add an item into a product list
                if (valid || this.product.get('item').get('_matrixChilds').length == 0) {
                  // Hide any other open flyout instances...

                  jQuery('.product-list-control-flyout').hide();

                  this.countedClicks[e.pageX + '|' + e.pageY] = false;

                  var self = jQuery(e.target);

                 if (Utils.isPhoneDevice()) {
                self.next().toggle();
                const body = jQuery('body');
                const scrollvalue = self.offset();

                body.animate({ scrollTop: scrollvalue.top }, '500', function() {
                    jQuery('#main').append('<div class="sc-flyout-bg"></div>');
                    jQuery('.sc-flyout-bg').on('click', function() {
                        jQuery('.sc-flyout-bg').remove();
                    });
                });
            } else {
                self.next().toggle();
            }
                } else {
                  
                  var self=this;
                  if(!self.errorTimer){
                  self.errorTimer=window.setTimeout(function(){
                    if(self.errorTimer){
                    window.clearTimeout(self.errorTimer);
                    self.errorTimer=0;
                    }
                    Tools.showErrorInModal(self.application, Utils.translate("Add to Saved Items"), Utils.translate("Please select a quantity for at least one option. Then click 'Add to Saved Items'."));
                  },100);
                }
                }
              }

            
          }

          var ProductListControlView=require("ProductList.Control.View");
          if(ProductListControlView.ProductListControlView){
            ProductListControlView=ProductListControlView.ProductListControlView;
          }

          ProductListControlView.prototype.addItemToList= function(line, productList, dontShowMessage) {
        
        var addItemPromise = jQuery.Deferred();
        if (line.isValid(true)) {
            
            var self = this;

            if (!productList.get('internalid')) {
                // this is a predefined list
                productList.save().done(function(data) {
                    var new_model = new ProductListModel(data);

                    self.application.ProductListModule.Utils.getProductLists().add(new_model, {
                        merge: true
                    });
                    self.doAddItemToList(line, new_model, dontShowMessage).then(() => {
                        addItemPromise.resolve();
                    });
                });
            } else {
                self.doAddItemToList(line, productList, dontShowMessage).then(() => {
                    addItemPromise.resolve();
                });
            }
        }else{
            var self = this;

            var matrixquantities = line.get("matrixquantities");

            if (!matrixquantities) {
                return;
            }
            var optionlist = [];
            var item_matrix_children = line.get('item').get('_matrixChilds');
            var options = line.getVisibleOptions();
            var newOption;
            for (var q in matrixquantities) { //Find the quantities and models and put them in a list.
                if (matrixquantities[q] > 0) {
                    newOption = { itemid: q, quantity: matrixquantities[q] };
                    optionlist.push(newOption);
                    for (var j = 0; j < item_matrix_children.models.length; j++) {
                        if (item_matrix_children.models[j].get("itemid") == q) {
                            console.log("Found " + q);
                            newOption.model = item_matrix_children.models[j];
                        }
                    }

                }
            }
            var lineoptions,cartOptionId, itemOptionId, values, label;
            //first set the options on the model
            for (var i = 0; i < optionlist.length; i++) {

                lineoptions = line.get("options");
                //console.log("lineoptions: "+JSON.stringify(lineoptions));

                for (var j = 0; j < lineoptions.models.length; j++) {
                    cartOptionId = lineoptions.models[j].get("cartOptionId");
                    itemOptionId = lineoptions.models[j].get("itemOptionId");
                    label = optionlist[i].model.get(itemOptionId);
                    values = lineoptions.models[j].get("values");
                    for (var k = 0; k < values.length; k++) {
                        if (values[k].label == label) {
                            lineoptions.models[j].set("value", {
                                "internalid": values[k].internalid,
                                "label": label
                            });
                            lineoptions.models[j].set("value.internalid", values[k].internalid);
                            lineoptions.models[j].set("value.label", label);
                            break;
                        }
                    }
                }


                this.doAddItemToList(line, productList, dontShowMessage);

            }
        }
        return addItemPromise;
    }


}
		};

	});
